import dayjs from "dayjs";
import _ from "lodash/fp";
import React from "react";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { numberValidation } from "../../common/constants/regex";
import { fromUTCDate, getFormattedDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/qualification.css";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import numberformat from "../labels/serial_nos_en.json";
import QualificationTypeDropdown from "./QualificationTypeDropdown";
import useQualificationActions from "./useQualificationActions";
const PhDGuideQualifiation = ({ setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, enableEditProfileWithLock, profileStatus }) => {
  const {
    handleQualificationChange,
    handleQualificationInfoSubmit,
    setActionType,
    setQualificationState,
    register,
    handleSubmit,
    errors,
    qualificationState,
    currentEditQualificationIndex,
    control,
  } = useQualificationActions();

  return (
    <form
      className="qualifcation_form"
      autoComplete="off"
      onSubmit={handleSubmit((e) => {
        handleQualificationInfoSubmit(e);
      })}
    >
      <div className="row">
        <QualificationTypeDropdown />
        <div className="col-md-4 mb-3 mt-3  responsive-input-phd-recog-date"  >
          <label className="float-start mb-0">
            {numberformat["4.2"]}&nbsp;
            {qualificationinformation.RECOGNITION_DATE}
            <span> {qualificationinformation_hindi.RECOGNITION_DATE_hin} </span>
            <span className="redColor">*</span>{" "}
          </label>
          <Controller
            name="recognitionDate"
            rules={{ required: true }}
            key={
              qualificationState.recognitionDate
                ? "recognitionDate"
                : "recognitionDate1"
            }
            defaultValue={
              qualificationState.recognitionDate
                ? dayjs(qualificationState.recognitionDate).toDate()
                : ""
            }
            control={control}
            render={({ onChange, value }) => (
              <DatePicker
                showIcon
                selected={
                  qualificationState.recognitionDate
                    ? dayjs(getFormattedDate(qualificationState.recognitionDate)).toDate()
                    : fromUTCDate(value)
                }
                onChange={(e) => {
                  setQualificationState({
                    ...qualificationState,
                    recognitionDate: toUTCDate(e),
                  });
                  onChange(toUTCDate(e));
                }}
                onKeyDown={preventDateManualTyping}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText={commonLabels.DATE_FORMAT}
                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                className="form-control bg-color"
                icon={
                  <img
                    src="/icons/calender.png"
                    className="date-picker-icon"
                    alt="date-icon"
                  ></img>
                }
              />
            )}
          />
          {_.get("recognitionDate.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 responsive-input-phd-reg-student">
          <label className="float-start mb-0">
            {numberformat["4.3"]}&nbsp;{qualificationinformation.YW_STUDENTS}
            <span> {qualificationinformation_hindi.YW_STUDENTS_hin} </span>
            <span className="redColor">*</span>{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.noStudentsRegisteredYw}
            maxLength={4}
            name="noStudentsRegisteredYw"
            ref={register({ required: true, pattern: numberValidation })}
            onInput={handleQualificationChange}

          />
          {_.get("noStudentsRegisteredYw.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("noStudentsRegisteredYw.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.Please_Enter_Only_Number}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-4 responsive-input-phd-guided">
          <label className="float-start mb-0">
            {numberformat["4.4"]}&nbsp;{qualificationinformation.GUIDED_BY}
            <span> {qualificationinformation_hindi.GUIDED_BY_hin} </span>
          </label>{" "}
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.guidedBy}
            name="guidedBy"
            onInput={handleQualificationChange}

          />
        </div>
        <div className="col-md-4 mb-3 mt-1 responsive-input-phd-comp-student">
          <label className="float-start mb-0">
            {numberformat["4.5"]}&nbsp;
            {qualificationinformation.NO_STUDENTS_RESEARCH_COMPLETED}
            <span>
              {" "}
              {
                qualificationinformation_hindi.NO_STUDENTS_RESEARCH_COMPLETED_hin
              }{" "}
              <span className="redColor">*</span>{" "}
            </span>
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.noStudentsResearchComplete}
            maxLength={4}
            name="noStudentsResearchComplete"
            ref={register({ required: true, pattern: numberValidation })}
            onInput={handleQualificationChange}

          />
          {_.get("noStudentsResearchComplete.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("noStudentsResearchComplete.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.Please_Enter_Only_Number}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-1 responsive-input-phd-awarded-student">
          <label className="float-start mb-0">
            {numberformat["4.6"]}&nbsp;
            {qualificationinformation.NO_STUDENTS_PHD_AWARDED}
            {qualificationinformation_hindi.NO_STUDENTS_PHD_AWARDED_hin}{" "}
            <span className="redColor">*</span>{" "}
            <span>
              {" "}
            </span>
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.noStudentsPhdAwarded}
            maxLength={4}
            name="noStudentsPhdAwarded"
            ref={register({ required: true, pattern: numberValidation })}
            onInput={handleQualificationChange}

          />
          {_.get("noStudentsPhdAwarded.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("noStudentsPhdAwarded.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.Please_Enter_Only_Number}
            </p>
          )}
        </div>
        {/* <div className="col-md-4 mb-3 responsive-input-phd-seat">
          <label className="float-start mb-0">
            {numberformat["4.7"]}&nbsp;
            {qualificationinformation.SEAT_NUMBER}
            <span className="redColor">*</span>{" "}
            {""}
            {qualificationinformation_hindi.SEAT_NUMBER_hin}{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            name="seatNumber"
            ref={register({ required: true })}
            defaultValue={
              qualificationState &&
              qualificationState.seatNumber
            }
            onInput={handleQualificationChange}

          />
          {_.get("seatNumber.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div> */}

        {/* <div className="col-md-4 mb-3 responsive-input-phd-year-pass">
          <label className="float-start mb-0">
            {numberformat["4.8"]}&nbsp;
            {qualificationinformation.YEAR_OF_PASSING}
            <span className="redColor">*</span>{" "}{" "}
            {qualificationinformation_hindi.YEAR_OF_PASSING_hin}{" "}
          </label>
          <select
            className="form-select  bg-color"
            name="yearOfPassing"
            maxLength={4}
            id="sq"
            ref={register({ required: true })}
            value={qualificationState.yea}
            defaultValue={
              qualificationState &&
              qualificationState.yearOfPassing
            }
            onInput={handleQualificationChange}
          >
            <option key={0} value="">
              {"Select Year"}
            </option>
            {getYearList()}
          </select>
          {_.get("yearOfPassing.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div> */}
      </div>
      <div className="text-center mb-5 mt-5">
        {
          profileStatus !== true ? (
            <>
              {currentEditQualificationIndex !== -1 ? (
                <button
                  type="submit"
                  name="edit"
                  className=" btn btn-primary custom_button  m-1"
                  onClick={() => {
                    setActionType("edit");
                    setActiveQualificationIndex("");
                    setActiveIntershipIndex("");
                    setActivePublicationIndex("");
                  }}
                >
                  {qualificationinformation.UPDATE}
                </button>
              ) : (
                <button
                  type="submit"
                  name="add"
                  className=" btn btn-primary custom_button  m-1"
                  onClick={() => {
                    setActionType("add");
                  }}
                >
                  {qualificationinformation.ADD}
                </button>
              )}
            </>
          ) : (
            enableEditProfileWithLock?.editProfileWithLock == "1" ? (
              (() => {
                const qualificationInfoList = enableEditProfileWithLock?.QualificationInfo?.split(",") || [];
                const canCreate = qualificationInfoList.includes("C");
                const canUpdate = qualificationInfoList.includes("U");

                if (currentEditQualificationIndex !== -1 && canUpdate) {
                  return (
                    <button
                      type="submit"
                      name="edit"
                      className=" btn btn-primary custom_button  m-1"
                      onClick={() => {
                        setActionType("edit");
                        setActiveQualificationIndex("");
                        setActiveIntershipIndex("");
                        setActivePublicationIndex("");
                      }}
                    >
                      {qualificationinformation.UPDATE}
                    </button>
                  );
                } else if (canCreate) {
                  return (
                    <button
                      type="submit"
                      name="add"
                      className=" btn btn-primary custom_button  m-1"
                      onClick={() => {
                        setActionType("add");
                      }}
                    >
                      {qualificationinformation.ADD}
                    </button>
                  );
                }

              })()
            ) : ""
          )
        }

      </div>
    </form>
  );
};
export default PhDGuideQualifiation;
